import SetRangeTitle from "./SetRangeTitle";

export default SetRangeTitle;
